module.exports = __webpack_public_path__ + "static/media/logo-comego.05f8fab8.png";